export default {
  'dynamicEntityGroup.title': 'Gestionar Grupo de Entidades Dinámicas',

  'dynamicEntityGroup.form.id': 'ID',
  'dynamicEntityGroup.form.enable': 'Habilitar',
  'dynamicEntityGroup.form.name': 'Nombre',
  'dynamicEntityGroup.form.description': 'Descripción',

  'dynamicEntityGroup.form.statusLabel': '¿Elemento Habilitado?',

  'dynamicEntityGroup.enabled': 'Habilitado',
  'dynamicEntityGroup.disabled': 'Deshabilitado',

  'dynamicEntityGroup.entities': 'Entidades',
};
